import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  version: "1.1",
  id: "__Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "1831.8 0 45 45",
  "enable-background": "new 1831.8 0 45 45",
  "xml:space": "preserve"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M1867.7,10.2c-1.3-1.2-3.1-1.5-4.7-0.7c-1.5,0.8-2.4,2.5-2.1,4.2c-0.7,0.7-1.3,1.3-2,2\r\n\tc-0.3-0.2-0.5-0.4-0.8-0.6c-0.4-0.3-0.9-0.2-1.2,0.2c-0.3,0.4-0.2,0.9,0.2,1.2c0.2,0.1,0.4,0.3,0.6,0.4c-0.4,0.4-0.7,0.7-1.1,1.1\r\n\tc-0.3-0.2-0.5-0.4-0.8-0.6c-0.4-0.3-0.9-0.2-1.2,0.2c-0.3,0.4-0.2,0.9,0.2,1.2c0.2,0.1,0.4,0.3,0.6,0.4c-0.4,0.4-0.7,0.7-1.1,1.1\r\n\tc-0.3-0.2-0.5-0.4-0.8-0.6c-0.4-0.3-0.9-0.2-1.2,0.2c-0.3,0.4-0.2,0.9,0.2,1.2c0.2,0.1,0.4,0.3,0.6,0.4c-0.4,0.4-0.9,0.9-1.3,1.3\r\n\tc-0.4-0.4-0.8-0.8-1.2-1.2c-0.3-0.3-0.7-0.3-1,0c-0.6,0.6-1.1,1.1-1.7,1.7c-1,1-1.1,2.6-0.3,3.7c-0.5,0.5-1.1,1.1-1.6,1.6\r\n\tc-1.7-0.3-3.4,0.6-4.2,2.1c-0.8,1.5-0.5,3.4,0.7,4.7s3,1.6,4.6,0.9c1.6-0.7,2.5-2.4,2.3-4.1c0.6-0.6,1.1-1.1,1.7-1.7\r\n\tc1.1,0.8,2.7,0.7,3.7-0.3c0.6-0.6,1.1-1.1,1.7-1.7c0.3-0.3,0.3-0.7,0-1c-0.4-0.4-0.8-0.8-1.2-1.2c0.7-0.7,1.3-1.3,2-2\r\n\tc0.2,0.2,0.5,0.3,0.7,0.5c0.4,0.3,0.9,0.2,1.2-0.2c0.3-0.4,0.2-0.9-0.2-1.2c-0.2-0.1-0.3-0.2-0.5-0.3c0.4-0.4,0.7-0.7,1.1-1.1\r\n\tc0.2,0.2,0.5,0.3,0.7,0.5c0.4,0.3,0.9,0.2,1.2-0.2c0.3-0.4,0.2-0.9-0.2-1.2c-0.2-0.1-0.3-0.2-0.5-0.3c0.4-0.4,0.7-0.7,1.1-1.1\r\n\tc0.2,0.2,0.5,0.3,0.7,0.5c0.4,0.3,0.9,0.2,1.2-0.2c0.3-0.4,0.2-0.9-0.2-1.2c-0.2-0.1-0.3-0.2-0.5-0.3c0.5-0.5,1-1,1.5-1.5\r\n\tc1.7,0.2,3.4-0.8,4.1-2.3C1869.3,13.2,1868.9,11.4,1867.7,10.2z M1845.4,35.1c-1.3,0.1-2.4-0.9-2.5-2.2s0.9-2.4,2.2-2.5\r\n\tc1.3-0.1,2.4,0.9,2.5,2.2C1847.7,33.9,1846.7,35,1845.4,35.1z M1848.7,30.6c-0.3-0.5-0.7-0.9-1.1-1.2c0.4-0.4,0.7-0.7,1.1-1.1\r\n\tc0.4,0.4,0.8,0.8,1.1,1.1C1849.4,29.8,1849.1,30.2,1848.7,30.6z M1853.6,29.2c-0.2,0.2-0.4,0.3-0.7,0.4c-0.3,0.1-0.5,0-0.8-0.1\r\n\tc-0.1-0.1-0.2-0.1-0.3-0.2c-0.3-0.3-0.6-0.6-0.9-0.9c-0.4-0.4-0.8-0.8-1.1-1.1c-0.3-0.3-0.6-0.6-0.9-0.9c-0.1-0.1-0.2-0.2-0.2-0.3\r\n\tc-0.1-0.2-0.2-0.5-0.1-0.8c0-0.3,0.2-0.5,0.4-0.7c0.4-0.4,0.7-0.7,1.1-1.1c1.4,1.4,2.7,2.7,4.1,4.1c0.2,0.2,0.4,0.4,0.6,0.6\r\n\tC1854.3,28.5,1854,28.9,1853.6,29.2z M1854,25.2l-1.1-1.1l1.6-1.6l1.3,0.9L1854,25.2z M1857,22.2l-1.3-0.9l1.1-1.1l1.3,0.9\r\n\tL1857,22.2z M1859.3,19.9L1858,19l1.1-1.1l1.3,0.9L1859.3,19.9z M1861.6,17.6c-0.4-0.3-0.9-0.6-1.3-0.9c0.4-0.4,0.9-0.9,1.3-1.3\r\n\tc0.3,0.4,0.7,0.8,1.2,1.1C1862.4,16.9,1862,17.3,1861.6,17.6z M1865,15.5c-1.3,0.1-2.4-0.9-2.5-2.2c-0.1-1.3,0.9-2.4,2.2-2.5\r\n\tc1.3-0.1,2.4,0.9,2.5,2.2C1867.3,14.3,1866.3,15.4,1865,15.5z"
    }, null, -1),
    _createElementVNode("line", {
      fill: "currentColor",
      x1: "1862.8",
      y1: "14.2",
      x2: "1862.8",
      y2: "14.2"
    }, null, -1),
    _createElementVNode("circle", {
      fill: "currentColor",
      cx: "1845.3",
      cy: "32.7",
      r: "0.8"
    }, null, -1),
    _createElementVNode("circle", {
      fill: "currentColor",
      cx: "1864.9",
      cy: "13.1",
      r: "0.8"
    }, null, -1)
  ])))
}
export default { render: render }